const FieldName = {
    ACCOUNT: "7FF63370-B53F-11EA-B900-E989F81A2C16",
    LOCATION: "9CB02710-B507-11EA-B900-E989F81A2C16",
}

export {
    FieldName
}
